export default __webpack_public_path__ + "static/media/map.e1ee8115.png";